module.exports = __webpack_public_path__ + "img/deletedForeverWhite.a17b759c.svg";